import { render } from "./OtherPayments.vue?vue&type=template&id=1ecfec30&scoped=true"
import script from "./OtherPayments.vue?vue&type=script&lang=js"
export * from "./OtherPayments.vue?vue&type=script&lang=js"

import "./OtherPayments.vue?vue&type=style&index=0&id=1ecfec30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecfec30"]])

export default __exports__